var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"processBox"},[_c('div',{staticClass:"processText",style:('width:' + _vm.process + '%')}),_c('span',{staticClass:"processDes"},[_vm._v(_vm._s(_vm.son)+" / "+_vm._s(_vm.father))])])
}
var staticRenderFns = []

export { render, staticRenderFns }